module.exports = __webpack_public_path__ + "img/to_pass.8483d664.svg";